import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-bg">
        <div className="h-10 w-10 rounded-full border-4 border-brand-green/30 border-t-brand-green animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  if (role && user.role !== role) return <Navigate to="/admin/login" replace />;
  return children;
}
